import React, { Suspense } from 'react';
import { RecoilRoot } from 'recoil';
import { ConfigProvider } from 'antd';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from 'react-query';
import { GlobalStyle, ThemeProvider, globalAntTheme, theme } from '@/styles';
import { queryClient } from '@/configs';
import { Spinner } from '@/components';

type MainProviderProps = {
  children: React.ReactNode;
};

export function MainProvider({ children }: MainProviderProps) {
  return (
    <Suspense fallback={<Spinner />}>
      <GlobalStyle />
      <ConfigProvider theme={globalAntTheme}>
        <ThemeProvider theme={theme}>
          <RecoilRoot>
            <QueryClientProvider client={queryClient}>
              <BrowserRouter>
                {children}
              </BrowserRouter>
            </QueryClientProvider>
          </RecoilRoot>
        </ThemeProvider>
      </ConfigProvider>
    </Suspense>
  );
}
